<div class="ui-g ui-fluid">
  <div class="ui-g-12 background" >
    <div class="ui-g-12 ui-md-6 ui-lg-6">
      <h2 class="title">Renovaciones</h2>
    </div>
    <div class="ui-sm-12 ui-g-8 ui-md-3 ui-lg-3">
      <div class="cardGray3 ui-g-12 p-grid" style="border-radius: 8px; cursor: pointer; margin: 0;" (click)="coupons()" >
        <div class="ui-g-3"> <i class="pi pi-ticket" style="font-size: 2rem; color: #073C8F;"></i></div>
        <div class="ui-g-9"> <h2 style="margin: 0; margin-top: 6px;">Cupones</h2></div>   
      </div>
    </div>
    
  </div>
  <div class="ui-g-12 p-grid">
    <div class="ui-g-1 ui-md-2 ui-lg-2"></div>
    <p-tabView class="ui-g-12 ui-md-8 ui-lg-8" style="margin: 0 auto;">
      <p-tabPanel *ngFor="let tab of items;let i = index;" header="{{tab.key}}" style="background-image: url({{tab.icon}}); border: none;">
          <div class="cardGray ui-g-12 ui-md-10 ui-lg-10">
            <div *ngFor="let option of tab.options">
              <div *ngIf="option['key'].length > 0">
                <div class="ui-lg-12">
                  <div *ngIf="option['value'].length == 0" style="padding: 1%; padding-left: 2%; font-weight: bold;" class="ui-g-12">
                    <h2>{{option.key}}</h2>
                  </div>
                  <div *ngIf="option['value'].length > 0" class="card ui-g-12">
                    <div class="ui-g-12">
                      <p style="font-weight: 400; font-family: poppins;">{{option.key}}</p>
                      
                    </div>
                    <h3 style="margin-left: 7px;">{{option.value}}</h3>
                    <div class="ui-g-12" *ngIf="option['observations'] != ''">
                      <p >Observacion: {{option['observations']}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>  
          </div>
          
      </p-tabPanel>
    </p-tabView>
    <div class="ui-g-1 ui-md-2 ui-lg-2"></div>
    

  </div>

</div>
<!--
<ul *ngFor="let option of tab.options">
  <li>
    <div class="ui-g-2 ui-md-6 ui-sm-6">
      <div *ngIf="option['key'].length > 0" class="card ui-g-12" style="min-height: 170px; margin-bottom: 8px !important;">
        <div class="ui-g-12">
          <div class="ui-g-12" style="font-family: poppins; font-weight: 600;">{{option.key}}</div>
          <div class="ui-g-12">{{option.value}}</div>
          <div *ngIf="option['observations'] != null" class="ui-g-12">Observacion: {{option['observations']}}</div>
        </div>
      </div>
    </div>
  </li>
</ul>-->